<form [formGroup]="emailForm" (ngSubmit)="onContinue()">
	<div class="flex flex-col gap-3">
		<input
			formControlName="email"
			id="kiosk-email"
			name="email"
			type="email"
			autocomplete="username"
			placeholder="Email"
			pInputText
			pSize="small"
			fluid
			appToLowercase
			class="text-base!"
			[ngClass]="(emailForm | isFieldInvalid: 'email') ? ['ng-invalid', 'ng-dirty'] : []"
			[tooltipStyleClass]="'p-tooltip-error'"
			[pTooltip]="(emailForm | isFieldInvalid: 'email') ? 'Valid email is required' : ''"
		/>
		<p-button
			pRipple
			type="submit"
			fluid
			size="small"
			icon="pi pi-arrow-right"
			label="Continue"
			[loading]="isLoading()"
			[disabled]="emailForm.invalid || isLoading()"
		/>
	</div>
</form>

<app-kiosk-pin-dialog
	#pinSignInDialog
	[visible]="showPinDialog()"
	header="Enter PIN"
	description="Enter your 4-digit PIN to continue."
	confirmLabel="Sign In"
	[isSubmitting]="isLoading()"
	(visibleChange)="showPinDialog.set($event)"
	(pinConfirmed)="onPinConfirmed($event)"
/>

<app-kiosk-pin-dialog
	[visible]="showChangePinDialog()"
	header="Change PIN"
	description="Set a new 4-digit PIN before continuing."
	confirmLabel="Save PIN"
	[isSubmitting]="isLoading()"
	(visibleChange)="showChangePinDialog.set($event)"
	(pinConfirmed)="onChangePinConfirmed($event)"
/>
